export default "__VITE_ASSET__B6i6hif9__"